import { IFilter } from '../../../common/interfaces/IFilter';
import { isTaskViewable } from '../../detail/utilities/taskDetailUtilities';
import { TaskTypes, TaskTypeToTaskTitleMapping } from './taskTypes';

const ForReviewFilter: TaskTypes[] = [
  TaskTypes.MVR,
  TaskTypes.TRL,
  TaskTypes.RX,
  TaskTypes.MIB,
  TaskTypes.CRIMINAL_RECORDS,
  TaskTypes.DISCLOSURE,
  TaskTypes.LETTER,
  TaskTypes.ETI,
  TaskTypes.MIB_CODEBACK,
  TaskTypes.ORDER_MIB_CODEBACK,
  TaskTypes.ADDITIONAL_INFORMATION_FROM_CUSTOMER,
  TaskTypes.APS,
  TaskTypes.EHR,
  TaskTypes.INSURANCE_LABS,
  TaskTypes.LAB_PIQTURE,
  TaskTypes.MEDICAL_CLAIMS,
  TaskTypes.SCRIPT_CHECK,
  TaskTypes.MIB_CODE_DETAILS,
  TaskTypes.RULE_REVIEW,
  TaskTypes.DISPUTE,
  TaskTypes.ADDITIONAL_DOCUMENTS,
];

export const ForReviewCommonFilter: Map<TaskTypes, TaskTypes[]> = new Map([
  [TaskTypes.DISCLOSURE, [TaskTypes.DISCLOSURE, TaskTypes.QE_DISCLOSURE]],
  [
    TaskTypes.LETTER,
    [
      TaskTypes.SUBSTANDARD_LETTER,
      TaskTypes.OTAF_LETTER,
      TaskTypes.DECLINE_LETTER,
    ],
  ],
  [
    TaskTypes.MEDICAL_CLAIMS,
    [TaskTypes.MEDICAL_CLAIMS, TaskTypes.AUTO_MEDICAL_CLAIMS],
  ],
]);

export function getTaskTypeFilter(org: string) {
  const filters: IFilter[] = [];
  for (const taskType of ForReviewFilter) {
    if (isTaskViewable(org, taskType)) {
      // Generic case
      const filter = {
        label: TaskTypeToTaskTitleMapping[taskType],
        value: taskType,
      };

      /**
       * Custom label for MIB Codeback, different from the task title
       * In filter we show 'Codebacks Error' instead of 'Codebacks'
       */
      if (taskType === TaskTypes.MIB_CODEBACK) {
        filter.label = 'Codebacks Error';
      }
      filters.push(filter);
    }
  }
  return filters.sort((x, y) => x.label.localeCompare(y.label));
}
